export default "__VITE_ASSET__DLRPjLWB__"